var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMisc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.458333 26.458334",
    height: 30,
    width: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "35.2778px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#550000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00703
    },
    transform: "matrix(0.87578888,0,0,0.87578888,1.4995838,2.289453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 10.731825,21.207365 h 3.496774 v 4.375275 h -3.496774 z m 3.393421,-2.532146 h -3.290068 v -2.652726 q 0,-1.739774 0.482313,-2.859431 0.482314,-1.119657 2.032608,-2.601049 l 1.550294,-1.5330683 q 0.981853,-0.9129509 1.41249,-1.7225489 0.447863,-0.8095979 0.447863,-1.6536469 0,-1.5330685 -1.136882,-2.4804704 -1.119657,-0.9474019 -2.98001,-0.9474019 -1.360814,0 -2.9111076,0.6028921 -1.5330685,0.6028921 -3.203941,1.7569999 v -3.238392 q 1.619196,-0.98185283 3.272843,-1.46416652 1.6708726,-0.4823137 3.4450976,-0.4823137 3.16949,0 5.081519,1.67087242 1.929255,1.6708725 1.929255,4.4097252 0,1.3091372 -0.620117,2.4976959 -0.620118,1.1713333 -2.170412,2.6527251 l -1.515843,1.481392 q -0.809598,0.809598 -1.154108,1.274686 -0.327284,0.447863 -0.465088,0.8785 -0.103353,0.361736 -0.155029,0.8785 -0.05168,0.516765 -0.05168,1.41249 z",
    style: {
      strokeWidth: 1.00703,
      fill: "#550000"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisc);
export default __webpack_public_path__ + "static/media/misc.bdea82c488ab3e84fc06211966146a1c.svg";
export { ForwardRef as ReactComponent };